import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Themes from "./pages/Themes";
import Theme from "./pages/Theme";
import QuestionPage from "./pages/Question";
import Results from "./pages/Results";
import Register from "./pages/Register";
import Verify from "./pages/Verify";
import Profile from "./pages/Profile";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import Layout from "./components/Layout";
import { AuthProvider, useAuthState } from "./lib/useAuth";

export default function App() {
  const auth = useAuthState();
  return (
    <AuthProvider value={auth}>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/themes" element={<Themes />} />
          <Route path="/themes/:themeSlug" element={<Theme />} />
          <Route path="/questions/:questionId" element={<QuestionPage />} />
          <Route path="/results" element={<Results />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}
